import React from 'react';
import { formatArea, validateArea } from './utils';
import { toDecimalPoint } from '../../../utils/decimalUtils';
import DecimalInput from '../../fields/DecimalInput';

const TaxVydelSection = ({ displayData, localFormData, setLocalFormData }) => {
  return (
    <div className="group-section">
      <h4>Лесотаксационный выдел</h4>
      <div>
        <table className="table">
          <thead>
            <tr>
              <th>№ <span className="required">*</span></th>
              <th>S, га <span className="required">*</span></th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td className="coordinate-cell">
                <input
                  type="text"
                  name="vid"
                  id="form1-vid"
                  value={displayData.vid || ''}
                  onChange={(e) => {
                    const newData = { ...localFormData, vid: e.target.value };
                    setLocalFormData(newData);
                    if (setLocalFormData) {
                      setLocalFormData(prev => ({ ...prev, vid: e.target.value }));
                    }
                  }}
                  className={`form-control ${!displayData.vid ? 'required-field' : ''} coordinate-field`}
                />
              </td>
              <td className="coordinate-cell">
                <DecimalInput
                  name="sga"
                  id="form1-sga"
                  value={displayData.sga || ''}
                  onChange={(e) => {
                    const value = toDecimalPoint(e.target.value);
                    const shouldSyncSlp = !localFormData.slp || String(localFormData.slp) === String(localFormData.sga || '');
                    const newData = {
                      ...localFormData,
                      sga: value,
                      ...(shouldSyncSlp ? { slp: value } : {})
                    };
                    setLocalFormData(newData);
                    if (setLocalFormData) {
                      setLocalFormData(prev => {
                        const syncSlp = !prev.slp || String(prev.slp) === String(prev.sga || '');
                        return {
                          ...prev,
                          sga: value,
                          ...(syncSlp ? { slp: value } : {})
                        };
                      });
                    }
                  }}
                  onBlur={(e) => {
                    const value = e.target.value;
                    const formattedValue = formatArea(value);
                    const shouldSyncSlp = !localFormData.slp || String(localFormData.slp) === String(localFormData.sga || '');
                    const newData = {
                      ...localFormData,
                      sga: formattedValue,
                      ...(shouldSyncSlp ? { slp: formattedValue } : {})
                    };
                    setLocalFormData(newData);
                    if (setLocalFormData) {
                      setLocalFormData(prev => {
                        const syncSlp = !prev.slp || String(prev.slp) === String(prev.sga || '');
                        return {
                          ...prev,
                          sga: formattedValue,
                          ...(syncSlp ? { slp: formattedValue } : {})
                        };
                      });
                    }
                  }}
                  onKeyDown={(e) => {
                    if (e.key === '-' || e.key === 'Minus') {
                      e.preventDefault();
                    }
                  }}
                  placeholder="0.0000"
                  className={`form-control ${!displayData.sga || !validateArea(displayData.sga) ? 'required-field' : ''} coordinate-field`}
                />
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default TaxVydelSection;

